import styled from 'styled-components';


export const Container = styled.div.attrs({
  className: 'content'
})`
  @media only screen and (max-height: 768px) {
    padding-bottom: 24px;
  }
`;

export const FormGroupColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 10px;

  &:last-child {
    margin-right: 0;
  }
`;

export const ErrorMessageWrapper = styled.div`
  min-height: 20px; 
`;

export const TabHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 24px;

  h1 {
    flex: 1;
  }

  p {
    flex: 1;
    color: rgba(22,20,20,.2);
  }
`;

export const FormGroupLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start; /* Alinha os itens no topo */

  > div {
    margin: 0;
    max-width: 48%;
  }
`;



export const ContainerModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 20px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: 9999;

  @media (min-width: 768px) {
    max-width: 810px;
    max-height: 80vh;
    overflow-y:ß scroll;
  }

  @media (max-width: 767px) {
    max-width: 90vw;
    max-height: 75vh;
    width: 90vw;
    overflow-y: scroll;
  }
`
export const Button = styled.button`
padding: 5px 10px;
background-color: #007bff;
color: #fff;
border: none;
border-radius: 3px;
cursor: pointer;
margin-left: 15px;

:after {
  content: 'x';
      position: absolute;
      background-color: inherit;
      border-radius: 50%;
      top: 10px;
      right: 10px;
      font-size: 20px;
      width: 35px;
      height: 35px;
      line-height: 1em;
      vertical-align: middle;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
  }
`
